import { Pipe, PipeTransform } from "@angular/core";
import { DigLitSAConstants } from "../constants/DigitalLiteracyConstants";

@Pipe({
  name: "convertDigLitSlider",
})
export class ConvertDigLitSliderPipe implements PipeTransform {
  transform(value: any): string {
    const map: Map<number, string> = new Map<number, string>([
      [1, DigLitSAConstants.DIG_LIT_SA_SLIDER_NOT_AT_ALL],
      [2, DigLitSAConstants.DIG_LIT_SA_SLIDER_SLIGHTLY_CONFIDENT],
      [3, DigLitSAConstants.DIG_LIT_SA_SLIDER_FAIRLY_CONFIDENT],
      [4, DigLitSAConstants.DIG_LIT_SA_SLIDER_QUITE_CONFIDENT],
      [5, DigLitSAConstants.DIG_LIT_SA_SLIDER_CONFIDENT],
      [6, DigLitSAConstants.DIG_LIT_SA_SLIDER_VERY_CONFIDENT],
    ]);

    return map.get(parseInt(value));
  }
}

